// หน้าต่างตัวกรอง — ช่องเหมือนหน้าเดิม · สถานะรถกับหน่วยงานเป็นค่าร่างที่ Index คืนค่าเองตอนยกเลิก

import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Row, Select, Transfer } from 'antd'
import { ALL_STATUS } from '../lib/useVehicleLists'

const { Option } = Select

export default function FilterModal({
  visible,
  txt,
  vehicleStatus,
  onVehicleStatusChange,
  org,
  vehicleOptions,
  appliedVehicleIds,
  onOk,
  onCancel,
}) {
  const [targetKeys, setTargetKeys] = useState(appliedVehicleIds)
  const selects = useRef({})

  // เปิดทุกครั้งเริ่มจากค่าที่ใช้อยู่ — ยกเลิกแล้วรถที่ย้ายค้างไว้ก็หายไปด้วย
  useEffect(() => {
    if (visible) setTargetKeys(appliedVehicleIds)
  }, [visible, appliedVehicleIds])

  // เลือกแล้วปิด dropdown ทันที เหมือนหน้าเดิม
  const changed = (name, handler) => (...args) => {
    if (selects.current[name]) selects.current[name].blur()
    handler(...args)
  }

  // คลิกรายการเดียวย้ายฝั่งทันที ไม่ต้องกดปุ่มลูกศร เหมือนหน้าเดิม
  const onSelectChange = (fromLeft, fromRight) => {
    if (fromLeft.length) {
      setTargetKeys(keys => keys.concat(fromLeft.filter(k => keys.indexOf(k) === -1)))
    } else if (fromRight.length) {
      setTargetKeys(keys => keys.filter(k => fromRight.indexOf(k) === -1))
    }
  }

  const orgSelect = (name, label, options, value, handler) => (
    <Form.Item label={label}>
      <Select
        mode="multiple"
        style={{ width: '100%' }}
        ref={el => (selects.current[name] = el)}
        value={value}
        loading={org.loading[name]}
        onChange={changed(name, handler)}
      >
        {options.map(o => (
          <Option value={`${o.id}`} key={o.id}>
            {o.name}
          </Option>
        ))}
      </Select>
    </Form.Item>
  )

  return (
    <Modal
      style={{ top: 20 }}
      title={txt.filterTitle}
      visible={visible}
      width={700}
      okText={txt.ok}
      cancelText={txt.cancel}
      onOk={() => onOk(targetKeys)}
      onCancel={onCancel}
    >
      <Row type="flex" justify="center">
        <Form>
          <Form.Item label={txt.vehicleStatusLabel}>
            <Select
              mode="multiple"
              showArrow
              style={{ width: '100%' }}
              value={vehicleStatus}
              onChange={onVehicleStatusChange}
            >
              {ALL_STATUS.map(s => (
                <Option key={s} value={s}>
                  {txt.vehicleStatus[s]}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {orgSelect('division', txt.division, org.options.division, org.selected.division, org.handlers.onDivisionChange)}
          {orgSelect('department', txt.department, org.options.department, org.selected.department, org.handlers.onDepartmentChange)}
          {orgSelect('section', txt.section, org.options.section, org.selected.section, org.handlers.onSectionChange)}

          {/* โรงงานส่งชื่อเป็นค่า และ id อยู่ใน key — useOrgFilters อ่าน id จาก key */}
          <Form.Item label={txt.plant}>
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              ref={el => (selects.current.plant = el)}
              value={org.selected.plantKeys}
              loading={org.loading.plant}
              onChange={changed('plant', org.handlers.onPlantChange)}
            >
              {org.options.plant.map(o => (
                <Option value={o.name} key={o.id}>
                  {o.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label={txt.vehicleLabel}>
            <Transfer
              titles={[txt.itemLeft, txt.itemSelected]}
              dataSource={vehicleOptions.map(v => ({ key: v.id, name: v.plate_no }))}
              showSearch
              listStyle={{ width: 250, height: 300 }}
              selectedKeys={[]}
              operations={['>>', '<<']}
              targetKeys={targetKeys}
              onChange={setTargetKeys}
              onSelectChange={onSelectChange}
              render={item => `${item.name}`}
              filterOption={(input, item) =>
                item.name.toUpperCase().indexOf(input.toUpperCase()) !== -1
              }
            />
          </Form.Item>
        </Form>
      </Row>
    </Modal>
  )
}

FilterModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  txt: PropTypes.object.isRequired,
  vehicleStatus: PropTypes.array.isRequired,
  onVehicleStatusChange: PropTypes.func.isRequired,
  /** ผลของ useOrgFilters */
  org: PropTypes.object.isRequired,
  vehicleOptions: PropTypes.array.isRequired,
  appliedVehicleIds: PropTypes.array.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
